import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import FundraiserInfoForm, {
  FundraiserInfoProps,
} from "../../components/Forms/StartingYourFundraiser/Step2-FundraiserInfo/FundraiserInfoForm";

import person_icon from "../../images/ProgressBarIcons/complete_icons/Personal.png";
import shipping_icon from "../../images/ProgressBarIcons/complete_icons/Shipping.png";
import credit_card from "../../images/ProgressBarIcons/incomplete_icons/Payment.png";
import review_icon from "../../images/ProgressBarIcons/incomplete_icons/Review.png";
import heart_icon from "../../images/ProgressBarIcons/incomplete_icons/Thanks.png";

const FundraiserInfo = () => {
  const progress_bar_props = [
    { icon: person_icon, label: "Organization Info" },
    { icon: shipping_icon, label: "Fundraiser Info" },
    { icon: credit_card, label: "Primary/Secondary" },
    { icon: review_icon, label: "Assign Participants" },
    { icon: heart_icon, label: "Review & Create" },
  ];
  const currentStep = 2;

  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    document.title = "Create Your Fundraiser";
  }, []);

  if (!state) {
    return <div>No fundraiser information provided.</div>;
  }

  const fundraiserInfoProps: FundraiserInfoProps = {
    organization_id: state.organization_id,
    coordinator_name: state.coordinator_name,
    coordinator_email: state.coordinator_email,
    file_location_ref: state.file_location_ref,
    primary_color: state.primary_color,
    secondary_color: state.secondary_color,
    payment_method_id: state.payment_method_id,
    teamAdminName: state.teamAdminName,
    primaryDivisionName: state.primaryDivisionName,
    secondaryDivisionName: state.secondaryDivisionName,
  };

  return (
    <div className="page-wrapper">
      <div className="progress-bar">
        <ProgressBar steps={progress_bar_props} currentStep={currentStep} />
      </div>
      <FundraiserInfoForm {...fundraiserInfoProps} />
    </div>
  );
};

export default FundraiserInfo;
